import styled from 'styled-components';

/** Renders as <img> under reduced motion — same box either way. */
export const media = styled.video`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: var(--border-radius-border-radius-full);
    display: block;
    position: relative;
`;
